<template>
  <div id="page-index">
    <div class="page">
      <!-- Page Navigation -->
      <div class="d-none d-md-block nav-float">
        <div>
          <ul>
            <li>
              <a href="#" v-on:click.prevent="scrollPageTo('-what-is-ddos')"
                >What is DDoS?</a
              >
            </li>
            <li>
              <a href="#" v-on:click.prevent="scrollPageTo('-solution')"
                >Our Solution</a
              >
            </li>
            <li v-if="cat === 'gaming' || cat === 'servers'">
              <a href="#" v-on:click.prevent="scrollPageTo('-compare')"
                >Compare</a
              >
            </li>
            <li v-if="cat === 'gaming' || cat === 'servers'">
              <a href="#" v-on:click.prevent="scrollPageTo('-pricing')"
                >Pricing</a
              >
            </li>
            <li v-if="cat === 'gaming' || cat === 'servers'">
              <a href="#" v-on:click.prevent="scrollPageTo('-contact')"
                >Contact Us</a
              >
            </li>
          </ul>
          <button
            v-if="cat === 'hosts' || cat === 'enterprise'"
            class="create-btn"
            v-on:click.prevent="scrollPageTo('-contact')"
          >
            <span>Contact Us</span>
          </button>
          <router-link
            to="/signup"
            v-if="cat === 'gaming' || cat === 'servers'"
          >
            <button class="create-btn"><span>Sign Up</span></button>
          </router-link>
        </div>
      </div>
      <Navbar />
      <!--Header-->
      <Header :cat="cat">
        <div class="header-text">
          <div>
            <h2>Security at your scale</h2>
            <h1>Enterprise DDoS Security Solution</h1>
          </div>
        </div>
      </Header>
      <!--Clients-->
      <!----- TODO ----->
      <!--Support-->
      <!----- TODO ----->
      <!--Product reason-->
      <section ref="-what-is-ddos" class="section-product">
        <Explanation :cat="cat" />
      </section>
      <!--Provider reason-->
      <section ref="-solution" class="section-provider">
        <Solution :cat="cat" />
      </section>
      <!--Analyzer-->
      <section
        ref="-compare"
        v-if="cat === 'servers' || cat === 'gaming'"
        class="section-analyze"
      >
        <div class="container">
          <div id="results-dynamic-ct" class="row justify-content-center">
            <div
              v-if="!analyzing"
              class="col-sm-12 col-md-6 analyze-loading analyze-loading-text"
            >
              <div class="middle-text">
                <div class="row cont-pad">
                  <div class="col-10">
                    <h2>Compare with Cosmic Guard</h2>
                    <h1>See for yourself</h1>
                    <p>
                      We own and operate a network that we stand behind. Compare
                      us with another host or mitigation provider and see why
                      we're confident about our solution.
                    </p>
                  </div>
                </div>
                <div class="row cont-pad">
                  <div class="col-5">
                    <h4>Normal connections</h4>
                    <div class="flexible">
                      <i class="fas fa-times cross"></i>
                      <p class="t-none analysis-p">Anycast</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-times cross"></i>
                      <p class="t-none analysis-p">DDoS Mitigation</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-times cross"></i>
                      <p class="t-none analysis-p">BGP</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-times cross"></i>
                      <p class="t-none analysis-p">BYOIP</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-times cross"></i>
                      <p class="t-none analysis-p">99.9% DDoS SLA</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-times cross"></i>
                      <p class="t-none analysis-p">7-day Free Trial</p>
                    </div>
                  </div>
                  <div class="col-5">
                    <h4>Cosmic connection</h4>
                    <div class="flexible">
                      <i class="fas fa-check check"></i>
                      <p class="t-none analysis-p">Anycast</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-check check"></i>
                      <p class="t-none analysis-p">DDoS Mitigation</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-check check"></i>
                      <p class="t-none analysis-p">BGP</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-check check"></i>
                      <p class="t-none analysis-p">BYOIP</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-check check"></i>
                      <p class="t-none analysis-p">99.9% DDoS SLA</p>
                    </div>
                    <div class="flexible">
                      <i class="fas fa-check check"></i>
                      <p class="t-none analysis-p">7-day Free Trial</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :class="analyzingBoot">
              <AnalyzeCard ref="analyzeCard" v-on:is-analyzing="isAnalyzing" />
            </div>
          </div>
        </div>
      </section>
      <!--Pricing Slider-->
      <!----- TODO ----->
      <!-- Trial Signup -->
      <!----- TODO ----->
      <!--Contact Us-->
      <div ref="-contact">
        <Contact :cat="cat" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script lang="js">
import Navbar from '@/components/Navbar.vue';
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Contact from "@/components/Contact.vue";
import Explanation from "@/components/products/reusable/Explanation.vue";
import Solution from "@/components/products/reusable/Solution.vue";

export default {
	components: {
		Navbar,
		Header,
		Footer,
		Contact,
    Explanation,
    Solution
	},
	data() {
		return {
			cat: null,
			analyzing: false,
		}
	},
	computed: {
		analyzingBoot: function() {
			return {
				'col-md-6': !this.analyzing,
				'col-12': this.analyzing
			}
		},
	},
	methods: {
		isAnalyzing(value) {
			this.analyzing = value;
		},
		resetVars(value) {
			this.isAnalyzing(value);
			this.$refs.analyzeCard.reset();
		},
		scrollPageTo(navEl) {
			this.$refs[navEl].scrollIntoView({behavior: 'smooth'});
        },
	},
	watch: {
		'$route.name': function () {
			this.cat = this.$route.name;
			this.resetVars(false);
		}
	},
	mounted() {
		this.cat = this.$route.name;
		if (this.$route.params.id !== undefined) {
			let analyzeId = this.$route.params.id;
			this.$refs.analyzeCard.setIP(analyzeId);
			this.$refs.analyzeCard.submit();
		}
	},
};
</script>

<style scoped>
.nav-float {
  position: fixed;
  left: 15px;
  bottom: 15px;
  z-index: 500000;
}
.nav-float > div {
  z-index: 500000;
  width: 200px;
  border-radius: 15px;
  background-color: rgba(34, 51, 67, 0.8);
}
.nav-float ul {
  margin: 0;
  padding: 10px;
  list-style: none;
}
.nav-float li a {
  width: 100%;
  margin: 0 !important;
  text-align: left;
  display: block;
  color: #fff;
  margin-top: 0.4em !important;
  box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.1);
  display: block;
  color: #fff;
  border-radius: 15px;
  background-repeat: no-repeat;
  background-size: cover;
  transition: 0.5s box-shadow;
  background-position: center center;
  text-align: center;
  line-height: 2.5em;
  font-size: 16px;
}
.nav-float li a {
  background: none !important;
}
.nav-float li a:hover {
  box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);
}
.nav-float li a:hover {
  text-decoration: none;
}
.nav-float ul li a:hover {
  text-decoration: none;
}
.nav-float .create-btn {
  margin-left: 10px;
  width: 180px;
  height: 3em;
  padding: 0 !important;
  margin-top: 0;
  margin-bottom: 10px;
}
.nav-float .create-btn span {
  font-size: 16px !important;
}
.circle-imgs {
  display: flex;
  margin: auto;
  justify-content: space-evenly;
  margin-top: 1.5em;
}
section {
  position: relative;
  --section-margin: 5em;
}
.section-clients {
  margin: 1em 0 1em 0;
}
.section-support,
.section-product,
.section-provider {
  padding: var(--section-margin) 0;
}
.section-product {
  padding-top: 5em;
  padding-bottom: 5em;
}
.section-support {
  background-color: #141d28;
}
.section-product {
  background-color: #10161f;
}
.section-provider {
  background-color: #141e2b;
}
.textcol-height {
  display: flex;
}
.header-text {
  display: flex;
  height: 30em;
}
.header-text > div {
  margin: auto;
  margin-left: 0;
}
.header-text * {
  color: white;
  font-weight: 610;
}
.header-text h1 {
  font-size: 42px;
  line-height: 1.2em;
}
.product-text {
  text-align: left;
  margin-bottom: 1em;
  z-index: 100;
}
.img-circle {
  margin: auto;
  max-width: 400px;
  clip-path: circle(45% at center);
}
.middle-text {
  margin: auto;
}
.imgs {
  width: 6em;
  padding-bottom: 1em;
}
.server-icon {
  margin: 1.2em 0;
}
.icons {
  font-size: 4em;
  margin: 5px;
}
.product-text {
  padding-left: 40px;
  padding-right: 40px;
}
.section-product .container > h2 {
  padding-left: 24px;
}
.section-support .textcol-height > div {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
